import { render, staticRenderFns } from "./APVListIncomes.vue?vue&type=template&id=389a5d32&scoped=true&"
import script from "./APVListIncomes.vue?vue&type=script&lang=js&"
export * from "./APVListIncomes.vue?vue&type=script&lang=js&"
import style0 from "./APVListIncomes.vue?vue&type=style&index=0&id=389a5d32&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389a5d32",
  null
  
)

export default component.exports